export default __webpack_public_path__ + "static/tracker-79df7e437ae55050424782f81029e995.png";